// URL ของหน้า Inbox Center ที่เอามาฝัง
//
// ฝังผ่าน reverse proxy same-origin (/inbox → inboxcenter.datafirst.id) เพื่อให้
// iframe อ่าน localStorage ตัวเดียวกับ parent ได้ (token Wazzup อยู่ที่นั่น)
// scope เป็นรายแบรนด์ด้วย ?page=<pageId> ตามที่ฝั่ง Inbox Center รองรับ
// ตั้งค่า pageId ของแต่ละแบรนด์ได้ที่ Setting → Product → drawer ของแบรนด์นั้น
export function inboxUrl(page: string, pageIds: string[], extra?: { conv?: string }): string {
  const params = new URLSearchParams({ embed: "1" });
  // ผูกได้หลายเพจ — ส่งเป็นลิสต์คั่นคอมมา (Inbox Center กรองเหลือเฉพาะเพจเหล่านี้)
  if (pageIds.length) params.set("page", pageIds.join(","));
  // conv = เปิดห้องนั้นทันที (มาจากรายการ Inbox ในหน้า Overview)
  if (extra?.conv) params.set("conv", extra.conv);
  return `/inbox/${page}?${params}`;
}
